// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"468a3566","431":"a219813b","489":"37caafce","507":"c0a6b069","608":"43c81741","787":"ab0cf6de","880":"93115982"}[chunkId] + ".chunk.js";
};